// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyA2Q3rgkq_-BD2oULzEZZg18jW9vIJwTBw",
    authDomain: "premier-granites.firebaseapp.com",
    projectId: "premier-granites",
    storageBucket: "premier-granites.firebasestorage.app",
    messagingSenderId: "227830217548",
    appId: "1:227830217548:web:98e3853272e298b7172de9",
    measurementId: "G-9ZKQLE7TBX"
  };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);